// extracted by mini-css-extract-plugin
module.exports = {"root":"liquid-metal-button_root__te7D2"};